import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { Dialog, Divider, Box, TextField } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import { userFeedback } from "../../redux/slice/user-feedback";
import { getUserChats } from "../../redux/slice/get-user-chats";
import "./LikeDialog.scss";
import { useLocation } from "react-router-dom";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
export default function LikeDialog(props) {
  const { open, handleClose, chatId, userSessionId } = props;
  const dispatch = useDispatch();
  const [value, setValue] = React.useState("");

  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const authUser = useSelector((state) => state.auth.user);
  const userEmail = authUser?.email || "";
  const token = "__cookie__";
  // const client = queryParams.get('client');
  const client = "UT";
  const dispatchFeedbackAction = () => {
    const payload = {
      feedback: true, // ✅ boolean
      rating: 5, // ✅ optional (0–5) - pick your default or UI value
      feedback_text: value || "", // ✅ string
      feedback_option: "thumbs_up", // ✅ optional label (whatever you want)
    };

    const param = {
      sessionId: userSessionId,
      chatId: chatId,
      data: payload,
      userEmail,
      token,
      client,
    };

    dispatch(userFeedback(param))
      .unwrap()
      .then(() => {
        const payload = {
          sessionId: userSessionId,
          userEmail,
          token,
          client,
        };
        return dispatch(getUserChats(payload));
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    setValue("");
    handleClose();
  };

  const handleDialogClose = () => {
    handleClose();
    setValue("");
  };
  return (
    <BootstrapDialog
      onClose={handleDialogClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      maxWidth="sm"
      fullWidth="true"
      className="like-dialog-parent"
    >
      <DialogTitle
        className="like-dialog-title"
        sx={{ m: 0, p: 2, fontWeight: "bold", fontSize: "16px" }}
        id="customized-dialog-title"
      >
        Submit feedback
      </DialogTitle>
      <Typography
        className="like-dialog-sub-title"
        sx={{ pl: 2, fontSize: "12px", color: "#6F6F6F" }}
      >
        Give me much details you can, but do not include any private or
        sensitive information.
      </Typography>
      <IconButton
        aria-label="close"
        onClick={handleDialogClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent className="like-dialog-content">
        <TextField
          sx={{ marginBottom: "30px" }}
          id="outlined-multiline-static"
          placeholder="What did you like most about the response?"
          multiline
          rows={4}
          fullWidth
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="like-dialog-text-field"
        />
        <Divider />
        <Box className="like-dialog-buttons-holder">
          <Button
            variant="outlined"
            size="large"
            className="like-dialog-cancel-button"
            onClick={handleDialogClose}
          >
            Cancel
          </Button>
          <Button
            className="like-dialog-submit-button"
            variant="contained"
            size="large"
            onClick={dispatchFeedbackAction}
          >
            Submit
          </Button>
        </Box>
      </DialogContent>
    </BootstrapDialog>
  );
}
